import React from 'react'

const Loading = () => {
  return (
    <img style={{width:'42px', 'margin':'auto','display':'block'}} src="/img/loading.gif"/>
  )
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading.jsx